export default [
    {
        prefix: '/develop',
        children: [
            {
                path: 'auth_rule/index',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/develop/AuthRule.vue')
            },
            {
                path: 'menu/index',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/develop/menu/Index.vue')
            },
        ]
    },
]
